/* eslint-disable camelcase */
import { FirebaseOptions, initializeApp } from 'firebase/app'
import 'firebase/auth'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import 'firebase/firestore'
import {
  connectFirestoreEmulator,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore'
import 'firebase/storage'
import { connectStorageEmulator, getStorage } from 'firebase/storage'
import { getAnalytics } from 'firebase/analytics'
import { getAI, GoogleAIBackend } from 'firebase/ai'
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check'

// Your web app's Firebase configuration
export const firebaseConfig: FirebaseOptions = {
  apiKey: 'AIzaSyAfTj0LTDb-sk7YaFSLLAtJP0P-eWbHKts',
  authDomain: 'student-tracker-43fc4.firebaseapp.com',
  databaseURL: 'https://student-tracker-43fc4.firebaseio.com',
  projectId: 'student-tracker-43fc4',
  storageBucket: 'student-tracker-43fc4.appspot.com',
  messagingSenderId: '397510232608',
  appId: '1:397510232608:web:7ccc80a869b91f3f4f8a45',
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)
export const auth = getAuth()
export const firestore = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
})
export const storage = getStorage()
export const ai = getAI(app, { backend: new GoogleAIBackend() })

// Demo mode runs the app against an in-memory dataset with no backend, so the
// analytics and App Check integrations have nothing to talk to.
const isDemoMode = import.meta.env.VITE_DEMO_MODE === 'true'

// Initialize Analytics (skip in test environment, demo mode and when using emulator)
const isUsingEmulator = window.location.hostname === 'localhost' && import.meta.env.VITE_USE_EMULATOR === 'true'
export const analytics = !import.meta.env.VITEST && !isUsingEmulator && !isDemoMode ? getAnalytics(app) : null

// Initialize App Check (skip in test environment and demo mode)
if (!import.meta.env.VITEST && !isDemoMode) {
  if (import.meta.env.DEV) {
    // Use debug token for local development
    // Get your debug token from: https://console.firebase.google.com/project/student-tracker-43fc4/appcheck/apps
    // Then add it to your .env.local: VITE_APPCHECK_DEBUG_TOKEN=your_token_here
    const debugToken = import.meta.env.VITE_APPCHECK_DEBUG_TOKEN
    if (debugToken) {
      ;(self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken
    } else {
      // If no debug token provided, set to true to auto-generate one (will be logged to console)
      ;(self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true
    }
  }

  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider('6LfPAg4sAAAAANd1mwe2pW4DtaL2H1YNISq2IBbM'),
    isTokenAutoRefreshEnabled: true,
  })
}

if (window.location.hostname === 'localhost' && import.meta.env.VITE_USE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099')
  connectFirestoreEmulator(firestore, 'localhost', 8080)
  connectStorageEmulator(storage, 'localhost', 9199)
}
